import { Grid } from '@material-ui/core';
import React from 'react';
import { useLang } from '../../util/lang';

const WaitingUploadIdesignGrid = () => {
    const get = useLang();
    return (
        <Grid>
            <div style={{ textAlign: 'center', borderStyle: 'dashed', padding: '10px', margin: '10px 0px' }}>
                {get('@PatientInfo.case_info.filesList.waitingUploadIdesign')}
            </div>
        </Grid>
    );
};

export default WaitingUploadIdesignGrid;
